import React, {useState} from 'react';
import {StyleSheet, TouchableOpacity, View} from 'react-native';
import Modal from 'react-native-modal';
import {observer} from 'mobx-react';

import WishlistSolid from '../images/brand/svg/icons/Wishlist_1.svg';
import WishlistAdd from '../images/brand/svg/icons/Wishlist_2.svg';
import {AppRoute} from '../models/AppRoute';
import useAppNavigation from '../navigation/useAppNavigation';
import {useStores} from '../stores/use-stores';
import theme from '../style/theme';

import Button from './ui-controls/Button';

const WishlistButton = observer(({item}: {item: any}) => {
  const {wishlistStore, userStore} = useStores();
  const isFavourite = wishlistStore.isInWishlist(item.product_code);
  const [accountModal, setAccountModal] = useState(false);
  const navigation = useAppNavigation();

  const toggleWishlist = () => {
    if (!userStore.sessionToken) {
      setAccountModal(true);
    } else {
      if (isFavourite) {
        wishlistStore.removeItemFromWishlist(item);
      } else {
        wishlistStore.addItemToWishlist(item);
      }
    }
  };

  return (
    <View>
      <TouchableOpacity
        onPress={() => toggleWishlist()}
        style={styles.touchable}>
        {isFavourite ? (
          <WishlistSolid width={40} height={40} />
        ) : (
          <WishlistAdd width={40} height={40} />
        )}
      </TouchableOpacity>
      <Modal
        isVisible={accountModal}
        style={{
          width: '100%',
          marginLeft: 0,
          justifyContent: 'flex-end',
          marginBottom: 0,
        }}
        hasBackdrop={true}
        backdropColor="black"
        backdropOpacity={0.56}
        animationIn="slideInUp">
        <View style={styles.modalView}>
          <Button
            type="clear"
            onPress={() => {
              setAccountModal(false);
              navigation.navigate(AppRoute.ACCOUNT_NOT_LOGGED_IN);
            }}
            title="Please log in, or create an account, to build a wishlist"
            titleStyle={styles.buttonText}
            buttonStyle={styles.button}
          />
          <Button
            onPress={() => setAccountModal(false)}
            title="OK"
            titleStyle={styles.buttonText}
          />
        </View>
      </Modal>
    </View>
  );
});

export default WishlistButton;

const styles = StyleSheet.create({
  touchable: {},
  wishlistHolder: {
    backgroundColor: 'white',
    borderWidth: 0.5,
    borderRadius: 4,
    right: 0,
    position: 'absolute',
    bottom: 45,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
  },
  touchableClose: {
    backgroundColor: 'black',
    top: -100,
    bottom: -100,
    height: 500,
    position: 'absolute',
  },
  wishlistRowPress: {
    paddingHorizontal: 8,
    paddingTop: 8,
    paddingBottom: 8,
  },
  wishlistRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 85,
  },
  wishlistName: {
    color: 'black',
    fontSize: 16,
    marginRight: 8,
    flex: 5,
  },
  separator: {
    borderBottomWidth: 0.5,
    borderColor: 'grey',
    marginHorizontal: 4,
  },
  icon: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  // Modal
  modalView: {
    backgroundColor: 'white',
    borderRadius: 4,
    padding: 36,
    alignItems: 'center',
  },
  modalText: {
    fontSize: 16,
    marginBottom: 32,
    textAlign: 'center',
    color: theme.colour.text.heading.primary,
  },
  button: {
    marginBottom: 16,
    width: 280,
  },
  buttonText: {
    fontSize: 16,
  },
});
